import { CheckErrorMsg } from './checkErrorMsg';
export function isValid(nodes) {
    const isValid = [];
    nodes.forEach((node) => {
        if (node instanceof Text || node.name == undefined) {
            return;
        }
        if (node.tagName === 'EP-FORM-INPUT-DATE-PICKER') {
            node = node.shadowRoot.querySelector('ep-form-input-text');
        }
        if (node.validator !== null && node.validator !== undefined) {
            new CheckErrorMsg(node).checkErrorMsg(node.validator.getValidator());
            if (node.hasAttribute('not-valid')) {
                isValid.push(false);
            }
        }
    });
    return isValid.length === 0;
}
//# sourceMappingURL=isValid.js.map